import {
    CallRequestOverlayControllerProps,
    CallRequestOverlayViewProps,
} from './callRequestOverlayProps';
import { ChatControllerBaseConfig } from '../../../base';
import { CallRequestOverlayController } from './callRequestOverlayInterface';
import { CallRequestOverlayAggregate } from './callRequestOverlayModel';

export function createCallRequestOverlayController(
    config: ChatControllerBaseConfig
): CallRequestOverlayController {
    return {
        useProps(context, item, props): CallRequestOverlayViewProps {
            return {
                isOpen: props.isOpen,
                onClose: props.onClose,
                callStatus: props.callStatus, // Pass through the actual call status
                title: 'Audio call',
                callDuration: '00:00',
                content: {
                    integration: props.item.integration,
                    thread: props.item.thread,
                    onEnd: props.onEnd,
                },
            };
        },
    };
}
